<template>
  <div class="index-page-panel__stage">
    <div
      class="index-page-panel"
      :style="accent ? { '--index-accent': accent } : undefined"
    >
      <slot name="header" />
      <div v-if="$slots.pills" class="index-page-panel__pills">
        <slot name="pills" />
      </div>
      <div v-if="$slots.extra" class="index-page-panel__extra">
        <slot name="extra" />
      </div>
      <div v-if="$slots.toolbar" class="index-page-panel__toolbar">
        <slot name="toolbar" />
      </div>
      <div class="index-page-panel__body">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  /** Top accent stripe color (defaults to --index-primary). */
  accent: { type: String, default: '' },
})
</script>

<style src="../styles/index-page-panel.scss"></style>
